export default __webpack_public_path__ + "static/media/bissig.ceaed119.png";